import {Component, Input, OnInit} from '@angular/core';
import {DataCenterService} from '../../../service/data-center.service';
import {RequestDataService} from '../../../service/request-data.service';
import {UserInfoService} from '../../../service/user-info.service';
import {UtilsService} from '../../../service/utils.service';
import {AppConfigService} from '../../../service/app-config.service';
import {ConfirmModalService} from '../../../service/confirm-modal.service';
import {NzModalService} from 'ng-zorro-antd';
import {FormModalComponent} from '../../../basicComponent/form-modal/form-modal.component';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-input-rollover',
  templateUrl: './input-rollover.component.html',
  styleUrls: ['./input-rollover.component.css']
})
export class InputRolloverComponent implements OnInit {

  @Input() parentData: any;
  @Input() modeType = 'add';

  public today = moment().format('YYYY-MM-DD');

  public datas: any;
  public itemData: any = []; // wagon 明细表

  public allChecked = false;
  private indeterminate = false;

  constructor(
    private dataCenterService: DataCenterService,
    private requestData: RequestDataService,
    private userInfoService: UserInfoService,
    private requestService: RequestDataService,
    private util: UtilsService,
    private config: AppConfigService,
    private confirmModal: ConfirmModalService,
    private modalService: NzModalService
  ) {
  }

  private columnsJson: any = [
    {
      'column': 'IN_LOC_ID',
      'name': 'LOC_ID_NAME',
      'component': 'poplist',
      'lable': '转入库位',
      'comment': '转入库位',
      'placeholder': '请选择转入库位',
      'insertValue': null,
      'model': null,
      'dictionary': 'dfmc/basic/dict/BASIC_PLANT_LOCATOR.json',
      'dictionaryPF': null,
      'visible': true,
      'require': true,
      'columnGroup': [
        {
          'column': 'LOC_NAME',
          'name': 'LOC_NAME_NAME',
          'component': 'input',
          'lable': '转入库位',
          'comment': '转入库位',
          'placeholder': '请输入转入库位',
          'insertValue': null,
          'fromValue': 'name',
          'model': null,
          'visible': false,
          'require': false,
          'disable': ['add', 'modify'],
        }
      ]
    },
    {
      'column': 'STOCK_ID',
      'name': 'STOCK_ID_NAME',
      'component': 'poplist',
      'lable': '钢坯（卷）号',
      'comment': '钢坯（卷）号',
      'placeholder': '请选择钢坯（卷）号',
      'fromValue': 'code',
      'insertValue': null,
      'model': null,
      'dictionary': 'dfmc/basic/dict/MC_OUTBOUND_STOCK.json',
      'dictionaryPF': null,
      'visible': true,
      'require': true,
      'columnGroup': [
        {
          'column': 'DET_BATCH',
          'name': 'DET_BATCH_NAME',
          'component': 'input',
          'lable': '钢坯（卷）号',
          'comment': '钢坯（卷）号',
          'placeholder': '请输入钢坯（卷）号',
          'insertValue': null,
          'fromValue': 'name',
          'model': null,
          'visible': false,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'OUT_LOC_ID',
          'name': 'OUT_LOC_ID_NAME',
          'component': 'input',
          'lable': '转出库位',
          'comment': '转出库位',
          'placeholder': '请输入转出库位',
          'insertValue': null,
          'fromValue': 'LOC_ID',
          'model': null,
          'visible': false,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'OUT_LOC_NAME',
          'name': 'OUT_LOC_NAME_NAME',
          'component': 'input',
          'lable': '转出库位',
          'comment': '转出库位',
          'placeholder': '请输入转出库位',
          'insertValue': null,
          'fromValue': 'LOC_NAME',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'DET_SUPPLIER',
          'name': 'DET_SUPPLIER_NAME',
          'component': 'input',
          'lable': '厂家',
          'comment': '厂家',
          'placeholder': '请输入厂家',
          'insertValue': null,
          'fromValue': 'DET_SUPPLIER_DICT',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'DET_TEXT',
          'name': 'DET_TEXT_NAME',
          'component': 'input',
          'lable': '辅记码',
          'comment': '辅记码',
          'placeholder': '请输入辅记码',
          'insertValue': null,
          'fromValue': 'DET_TEXT',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'GOODS_MODEL',
          'name': 'GOODS_MODEL_NAME',
          'component': 'input',
          'lable': '货品型号',
          'comment': '货品型号',
          'placeholder': '请输入货品型号',
          'insertValue': null,
          'fromValue': 'MODEL_DICT',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'GOODS_MATERIAL',
          'name': 'GOODS_MATERIAL_NAME',
          'component': 'input',
          'lable': '材质',
          'comment': '材质',
          'placeholder': '请输入材质',
          'insertValue': null,
          'fromValue': 'MATERIAL_DICT',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'GROSS_WEIGHT',
          'name': 'GROSS_WEIGHT_NAME',
          'component': 'input',
          'lable': '毛重（实重）',
          'comment': '毛重（实重）',
          'placeholder': '请输入毛重（实重）',
          'insertValue': null,
          'fromValue': 'GROSS_WEIGHT',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        },
        {
          'column': 'NET_WEIGHT',
          'name': 'NET_WEIGHT_NAME',
          'component': 'input',
          'lable': '净重',
          'comment': '净重',
          'placeholder': '请输入净重',
          'insertValue': null,
          'fromValue': 'NET_WEIGHT',
          'model': null,
          'visible': true,
          'require': false,
          'disable': ['add', 'modify'],
        }
      ]
    }
  ];

  clearItemModel() {
    _.each(this.columnsJson, (oneColumn) => {
      _.set(oneColumn, 'model', null);
      let columnGroup = _.get(oneColumn, 'columnGroup', null);
      _.each(columnGroup, (oneGroupColumn) => {
        _.set(oneGroupColumn, 'model', null);
      });
    });
  }

  addItem() {
    this.clearItemModel(); // 清除 this.columnsJson 之上的 model
    this.modalService.create({
      nzTitle: '',
      nzContent: FormModalComponent,
      nzWidth: 1000,
      nzMaskClosable: false,
      nzWrapClassName: 'vertical-center-modal',
      nzComponentParams: {
        modalFormData: {
          'columns': this.columnsJson
        }
      },
      nzOnOk: (response) => {
        const data = response.modalFormData.columns;
        let requireCheck = true;
        _.each(data, oneColumn => {
          if (!this.util.Base_HasValue(oneColumn['model']) && oneColumn['require'] === true) {
            requireCheck = false;
          }
        });
        if (!requireCheck) {
          this.confirmModal.show('error', {title: '请填写必填信息。'});
          return false;
        }
        const detBatch = _.get(data, '1.itemArray.0.name', null);
        if (!this.checkDuplicateDetBatch(detBatch)) {
          return false;
        }
        const inLocId = _.get(data, '0.model');
        const outLocId = _.get(data, '1.itemArray.0.LOC_ID');
        if (inLocId === outLocId) {
          this.confirmModal.show('error', {title: '出库库位与入库库位一样，不能转仓。'});
          return false;
        }

        let oneTmpRow = [];
        _.each(data, oneColumn => {
          oneTmpRow[oneColumn['column']] = oneColumn['model'];
          let columnGroup = _.get(oneColumn, 'columnGroup', null);
          _.each(columnGroup, (oneGroupColumn) => {
            oneTmpRow[oneGroupColumn['column']] = _.get(oneGroupColumn, 'model', null);
          });
        });
        this.itemData.push(oneTmpRow);
      }
    });
  }

  checkDuplicateDetBatch(detBatch) {
    let result = true;
    _.each(this.itemData, oneRow => {
      const oneDetBatch = oneRow['DET_BATCH'];
      if (this.util.Base_HasValue(detBatch) && this.util.Base_HasValue(oneDetBatch)) {
        if (detBatch === oneDetBatch) {
          this.confirmModal.show('error', {title: '该钢批号' + oneDetBatch + '已经选用了'});
          result = false;
          return false;
        }
      }
    });
    return result;
  }

  // 明细table删除
  itemRemove(): void {
    const checkedList = _.filter(this.itemData, (item) => {
      return item['checked'];
    });
    if (checkedList.length) {
      this.confirmModal.show('confirm', {
        title: '温馨提示',
        content: '是否要删除该数据吗？',
        suc: () => {
          this.itemData = this.itemData.filter((item) => {
            return !item.checked;
          });
          this.refreshStatus();
        }
      });
    } else {
      this.confirmModal.show('warning', {
        title: '温馨提示',
        content: '请至少选择一条数据！'
      });
    }
  }

  checkAll(value: boolean): void {
    this.itemData.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    const validData = this.itemData.filter(value => !value.disabled);
    const allChecked = validData.length > 0 && validData.every(value => value.checked === true);
    const allUnChecked = validData.every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  selectMore(pListData): number {
    //计数，有多少条记录被勾选了。
    let iCount = 0;
    _.each(pListData, oneData => {
      if (oneData['checked']) {
        iCount++;
      }
    });
    if (iCount === 0) {
      this.confirmModal.show('warning', {
        'title': '温馨提示',
        'content': '请至少选择一条纪录！'
      });
      return iCount;
    }
    return iCount;
  }


  formatItemToEntity() {
    let entityList: any = [];
    _.each(this.itemData, (oneRow) => {
      let entity: any = {};
      _.each(_.keys(oneRow), (key) => {
        const column = _.camelCase(key);
        const value = _.get(oneRow, key);
        entity[column] = value;
      });
      entityList.push(entity);
    });
    return entityList;
  }


  // 返回
  gotoBack(): void {
    this.parentData.data = {};
    this.parentData.conditionColumns = {};
    this.parentData.formType = 'listForm';
    this.parentData.actionArray = [];
    // 覆盖当前数据到data-center;
    _.each(this.dataCenterService._dataObject.list, (item) => {
      if (item['id'] === this.parentData.id) {
        item = _.extend(item, this.parentData);
      }
    });
    this.dataCenterService.refreshDataCenterInStorage();
  }

  saveData() {

    const data = {
      'mcRolloverDetailList': this.formatItemToEntity()
    };
    this.requestService.doActionByHdbsthorDfmc('AppApi/McRolloverController', 'rolloverOut', data).subscribe(response => {
      if (response.toString() === 'true') {
        this.confirmModal.show('success', {'title': '执行成功'});
        this.gotoBack();
      } else {
        this.confirmModal.show('error', {'title': '执行成功错误如下', 'content': response.error.message});
      }
    });
  }

  ngOnInit(): void {

  }
}
